'use client';
import React, { useState } from 'react';
import { useToast } from '@practium/ui';
import { useForgotPassword } from '@practium/features/api';
import { AuthFormWrapper } from '../AuthFormWrapper/AuthFormWrapper';
import { AuthInput } from '../AuthInput/AuthInput';
import { AuthButton } from '../AuthButton/AuthButton';
import { validateEmail } from '../../validations/auth.validation';
import styles from './ForgotPasswordForm.module.css';

interface ForgotPasswordFormProps {
	initialEmail?: string;
	onBack?: () => void;
}

export const ForgotPasswordForm = ({ initialEmail = '', onBack }: ForgotPasswordFormProps) => {
	const toast = useToast();
	const [email, setEmail] = useState(initialEmail);
	const [sent, setSent] = useState(false);
	const { mutate: forgotPassword, isPending } = useForgotPassword();

	const handleSubmit = (e: React.SyntheticEvent) => {
		e.preventDefault();

		const emailValidation = validateEmail(email);
		if (!emailValidation.isValid) {
			toast.error(emailValidation.error!);
			return;
		}

		forgotPassword(email, {
			onSuccess: () => {
				setSent(true);
				toast.success('Um link de recuperação foi enviado para seu e-mail.');
			},
			onError: (err) => {
				toast.error(err instanceof Error ? err.message : 'Erro ao solicitar recuperação de senha');
			},
		});
	};

	return (
		<AuthFormWrapper onSubmit={handleSubmit} showDivider={false}>
			<AuthInput
				label="E-mail"
				type="email"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				placeholder="exemplo@gmail.com"
				required
			/>

			<div className={styles.buttons}>
				<AuthButton type="submit" variant="primary" fullWidth isLoading={isPending}>
					{sent ? 'Reenviar link' : 'Enviar link'}
				</AuthButton>

				<button type="button" className={styles.backButton} onClick={onBack}>
					Voltar
				</button>
			</div>

			<p className={styles.hint}>
				Não recebeu o e-mail? Verifique a pasta de spam ou aguarde alguns minutos antes de tentar novamente.
			</p>
		</AuthFormWrapper>
	);
};
